"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserScore = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("../../interfaces");
var UserScore = (function (_super) {
    tslib_1.__extends(UserScore, _super);
    function UserScore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserScore.prototype.setScoreSession = function (value) {
        if (isNaN(value)) {
            this._sessionScore = NaN;
        }
        else {
            var prev = this._sessionScore || 0;
            this._sessionScore = value;
            if (value >= prev) {
                this.emit(interfaces_1.ScoreEvent.INCREASED);
            }
            this.emit(interfaces_1.ScoreEvent.UPDATED);
        }
    };
    UserScore.prototype.update = function (context, global) {
        this._contextScore = context || this._contextScore;
        this._globalScore = global || this._globalScore;
        if (global || context) {
            this.emit(interfaces_1.ScoreEvent.UPDATED);
        }
    };
    UserScore.prototype.getScore = function (mask) {
        if (mask === void 0) { mask = interfaces_1.ScoreType.SESSION | interfaces_1.ScoreType.CONTEXT | interfaces_1.ScoreType.GLOBAL; }
        var hasFlag = function (flag, msk) { return !!(msk & flag); };
        var scoresToCheck = [];
        if (hasFlag(interfaces_1.ScoreType.SESSION, mask)) {
            scoresToCheck.push(this._sessionScore);
        }
        if (hasFlag(interfaces_1.ScoreType.CONTEXT, mask)) {
            scoresToCheck.push(this._contextScore && this._contextScore.getScore());
        }
        if (hasFlag(interfaces_1.ScoreType.GLOBAL, mask)) {
            scoresToCheck.push(this._globalScore && this._globalScore.getScore());
        }
        scoresToCheck = scoresToCheck.filter(function (s) { return !isNaN(s); });
        if (scoresToCheck.length) {
            return Math.max.apply(null, scoresToCheck);
        }
    };
    UserScore.prototype.getEntry = function (type) {
        switch (type) {
            case interfaces_1.ScoreType.GLOBAL:
                return this._globalScore;
            case interfaces_1.ScoreType.CONTEXT:
                return this._contextScore;
        }
    };
    UserScore.prototype.flush = function () {
        delete this._contextScore;
        delete this._sessionScore;
    };
    return UserScore;
}(core_1.EventDispatcher));
exports.UserScore = UserScore;
//# sourceMappingURL=UserScore.js.map